import styles from "./borrowingCapacityApllicantInfo2.module.css";
import CurrencyInput from "react-currency-input-field";

const BorrowingCapacityApllicantInfo2 = ({
  monthlyRentalIncome,
  onRentalIncomeChange,
  creditCardLimit,
  onCreditCardChange,
  personalLoanRepay,
  onPersonalLoanChange,
  homeLoanRepay,
  onHomeLoanRepayChange,
}) => {
  return (
    <>
      {/* 📌 Step 2 Heading + Divider */}
      <h2 className={styles.heading}>Step 2 of 2</h2>
      <hr className={styles.divider} />

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Monthly Rental Income</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input}`}
            id="bcMonthlyRent"
            defaultValue={monthlyRentalIncome}
            decimalsLimit={2}
            onValueChange={(value) => onRentalIncomeChange(value)}
          />
        </div>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Credit Card Limits (Total)</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input}`}
            id="bcCreditCard"
            defaultValue={creditCardLimit}
            decimalsLimit={2}
            onValueChange={(value) => onCreditCardChange(value)}
          />
        </div>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Personal Loan Repayments (Monthly)</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input}`}
            id="bcPersonalLoan"
            defaultValue={personalLoanRepay}
            decimalsLimit={2}
            onValueChange={(value) => onPersonalLoanChange(value)}
          />
        </div>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Home Loan Repayments (Monthly)</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input}`}
            id="bcHomeLoan"
            defaultValue={homeLoanRepay}
            decimalsLimit={2}
            onValueChange={(value) => onHomeLoanRepayChange(value)}
          />
        </div>
      </div>
    </>
  );
};

export default BorrowingCapacityApllicantInfo2;
